import { render } from "./UmsSendLayer.vue?vue&type=template&id=32e1535d"
import script from "./UmsSendLayer.vue?vue&type=script&lang=js"
export * from "./UmsSendLayer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__